export const decimals = 10 ** 18;
export const crypto_kitties_url = "https://api.cryptokitties.co/kitties/83";
export const forbid_words = ["asu", "anjing"];